import { parse } from 'psl';

const isPSL = (domain: string) => {
  const parsed = parse(domain);

  return (parsed && 'tld' in parsed && parsed.tld === domain) ?? false;
};

export const getRootDomain = (hostname: string) => {
  const urlParts = hostname.split('.');

  return urlParts
    .slice(0)
    .slice(-(urlParts.length === 4 ? 3 : 2))
    .join('.');
};

export const getCookie = (name: string) => {
  const nameString = name + '=';
  const value = document.cookie.split('; ').find((row) => row.startsWith(nameString));

  return value ? (value.split('=')?.[1] as string) : null;
};

type SetCookieParams = {
  name: string;
  value: string;
  days?: number;
  expires?: string;
  useRootDomain?: boolean;
};

export const setCookie = (params: SetCookieParams) => {
  const { name, value, days, expires, useRootDomain } = params;

  let expiresString = '';
  if (expires) {
    expiresString = `expires=${new Date(expires).toUTCString()};`;
  } else if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expiresString = `expires=${date.toUTCString()};`;
  }

  const domain = getRootDomain(window.location.hostname);
  let cookieString = `${name}=${value}; path=/; ${expiresString}`;
  if (!isPSL(domain) && useRootDomain) {
    cookieString += ` domain=.${domain};`;
  }

  document.cookie = cookieString;
};

export const removeCookie = (name: string) => {
  const domain = getRootDomain(window.location.hostname);
  let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
  if (!isPSL(domain)) {
    cookieString += ` domain=.${domain}`;
  }
  document.cookie = cookieString;
};
